<template>
  <div class="about-container container">
     <div class="profile-picture">
       <img src="../assets/poza_mea.jpeg" />
     </div>
    <div class="title">
      <p>
        {{ about1 }}
      </p>
      <p>
        {{about2}}
      </p>
    </div>
  </div>
</template>
<script>
import { ABOUT_1, ABOUT_2 } from '../constants';
export default {
  name: 'About',
  data() {
    return {
      about1: ABOUT_1,
      about2: ABOUT_2,
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../scss/_variables.scss";
.about-container {
  color: $theme-color;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: row;

  .title {
    font-size: 18px;
    font-weight: 500;
    text-indent: 50px;
    margin-top: 10px;
    font-weight: 500;
    text-align: justify;
    padding: 0 0 30px 35px;
  }
  .profile-picture {
    margin: 30px 0;

    img {
      border-radius: 28% 0 0 0;
      height: 500px;
    }
  }
  .ciocan-judecator {
    text-align: center;
    margin-bottom: 20px;
  }
  .moto {
    color: red;
    font-style: italic;
    font-size: 22px;
    margin-top: 20px;
  }
}
@media only screen and (min-width: 1200px) { 
  .about-text {
    width: 56vw !important;
  }
}

@media only screen and (max-width: 991px) {
  .about-container { 
    flex-direction: column;
  }
}
@media only screen and (min-width: 615px) and (max-width: 991px) {
  .about-container .profile-picture img {
    height: 65vw;
  }
}
@media only screen and (min-width: 533px) and (max-width: 615px) {
  .about-container .profile-picture img {
    height: 80vw;
  }
}
@media only screen and (max-width: 533px) {
  .about-container .profile-picture img {
    height: 95vw;
  }
}
@media only screen and (max-width: 615px) {
  .about-container {
    .title {
      padding: 0 10px 30px;
    }
  }
}

@media only screen and (max-width: 533px) {
  .about-container {
    .title {
      padding: 0 10px 30px;
    }
  }
}
</style>